import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { Box, Button, Container, Grid, Input, SpaceBetween, StatusIndicator, Tabs, Link, SegmentedControl } from "@amzn/awsui-components-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { useHistory, useLocation } from "react-router-dom";
import { convertToLocalTime } from "./Utility";
import './styles.scss';
import tieoutLogo from '../../images/tieoutLogo.png'
import aiInsights from '../../images/aiInsights.svg'
import { getDocumentTreeWithTracks } from "./DocumentStoreAPIs";
import TieOutHistoryComponent from "./TieOutHistoryComponent";
import { createPreference, deletePreference, listPreference } from "src/utilities/AppSyncPlusAPIs";
import { deepEqual } from "src/Ateam-BI/utils/generalUtils";
import { v4 as uuidv4 } from 'uuid';
import DownloadTieOutResultsButton from "./DownloadTieOutResultsButton";


const mockGetDocuments = (selectedId) => {
    const preDocs = [
        { section: "Cover Page", version: "Pre-WB", workiva_export_timestamp: "1/1/2026 8:00 AM PST", execution_completion: "1/1/2026 8:00 AM PST", status: "Tie-Out Created", last_updated: "12/31/2025 8:00 AM PST" },
        { section: "I7.29 - Effects of FX", version: "Pre-WB", workiva_export_timestamp: "1/1/2026 8:00 AM PST", execution_completion: "1/1/2026 8:00 AM PST", status: "Tie-Out Marked Complete", last_updated: "12/31/2025 8:00 AM PST" },
        { section: "Guidance", version: "Pre-WB", workiva_export_timestamp: "No file available", execution_completion: "1/1/2026 8:00 AM PST", status: "Not Run", last_updated: "12/31/2025 8:00 AM PST" },
        { section: "Note 7 — Commitments and Contingencies", version: "Pre-WB", workiva_export_timestamp: "1/1/2026 8:00 AM PST", execution_completion: "1/1/2026 8:00 AM PST", status: "Tie-Out Created", last_updated: "12/31/2025 8:00 AM PST" },
        { section: "Note 5.3 Intangibles", version: "Pre-WB", workiva_export_timestamp: "No file available", execution_completion: "Support files not available", status: "Not Run", last_updated: "12/31/2025 8:00 AM PST" },
        { section: "Consolidated Statement of Operations", version: "Pre-WB", workiva_export_timestamp: "1/1/2026 8:00 AM PST", execution_completion: "1/1/2026 8:00 AM PST", status: "Tie-Out Marked Complete", last_updated: "12/31/2025 8:00 AM PST" },
        { section: "Note 3 — Revenue Recognition", version: "Pre-WB", workiva_export_timestamp: "1/1/2026 8:00 AM PST", execution_completion: "1/1/2026 8:00 AM PST", status: "Tie-Out Created", last_updated: "12/31/2025 8:00 AM PST" },
        { section: "Balance Sheet", version: "Pre-WB", workiva_export_timestamp: "1/1/2026 8:00 AM PST", execution_completion: "1/1/2026 8:00 AM PST", status: "Tie-Out Marked Complete", last_updated: "12/31/2025 8:00 AM PST" },
        { section: "Cash Flow Statement", version: "Pre-WB", workiva_export_timestamp: "1/1/2026 8:00 AM PST", execution_completion: "1/1/2026 8:00 AM PST", status: "Tie-Out Created", last_updated: "12/31/2025 8:00 AM PST" },
    ];

    const postDocs = [
        { section: "Stockholders' Equity Summary", version: "Post-WB", workiva_export_timestamp: "2/15/2026 9:00 AM PST", execution_completion: "2/15/2026 9:15 AM PST", status: "Tie-Out Marked Complete", last_updated: "2/15/2026 9:20 AM PST" },
        { section: "Note 4 — Leases & Operating Obligations", version: "Post-WB", workiva_export_timestamp: "2/15/2026 9:30 AM PST", execution_completion: "2/15/2026 9:48 AM PST", status: "Tie-Out Created", last_updated: "2/15/2026 10:00 AM PST" },
        { section: "Segment Reporting — AWS", version: "Post-WB", workiva_export_timestamp: "2/15/2026 10:00 AM PST", execution_completion: "2/15/2026 10:22 AM PST", status: "Tie-Out Marked Complete", last_updated: "2/15/2026 10:30 AM PST" },
        { section: "Note 9 — Income Taxes", version: "Post-WB", workiva_export_timestamp: "2/15/2026 10:30 AM PST", execution_completion: "2/15/2026 10:55 AM PST", status: "Tie-Out Marked Complete", last_updated: "2/15/2026 11:00 AM PST" },
        { section: "Earnings Per Share", version: "Post-WB", workiva_export_timestamp: "2/15/2026 11:00 AM PST", execution_completion: "2/15/2026 11:18 AM PST", status: "Tie-Out Created", last_updated: "2/15/2026 11:25 AM PST" },
        { section: "Note 6 — Debt & Credit Facilities", version: "Post-WB", workiva_export_timestamp: "2/15/2026 11:30 AM PST", execution_completion: "2/15/2026 11:52 AM PST", status: "Tie-Out Marked Complete", last_updated: "2/15/2026 12:00 PM PST" },
        { section: "Comprehensive Income Statement", version: "Post-WB", workiva_export_timestamp: "2/15/2026 12:00 PM PST", execution_completion: "2/15/2026 12:35 PM PST", status: "Not Run", last_updated: "2/15/2026 12:40 PM PST" },
        { section: "Note 2 — Fair Value Measurements", version: "Post-WB", workiva_export_timestamp: "2/15/2026 1:00 PM PST", execution_completion: "2/15/2026 1:20 PM PST", status: "Tie-Out Marked Complete", last_updated: "2/15/2026 1:30 PM PST" },
        { section: "Goodwill & Acquired Intangibles", version: "Post-WB", workiva_export_timestamp: "2/15/2026 1:30 PM PST", execution_completion: "2/15/2026 1:50 PM PST", status: "Tie-Out Created", last_updated: "2/15/2026 2:00 PM PST" },
        { section: "Note 10 — Pension & Benefits", version: "Post-WB", workiva_export_timestamp: "2/15/2026 2:15 PM PST", execution_completion: "2/15/2026 2:40 PM PST", status: "Tie-Out Marked Complete", last_updated: "2/15/2026 2:45 PM PST" },
        { section: "Related Party Transactions", version: "Post-WB", workiva_export_timestamp: "2/15/2026 3:00 PM PST", execution_completion: "2/15/2026 3:25 PM PST", status: "Not Run", last_updated: "2/15/2026 3:30 PM PST" },
        { section: "Note 11 — Subsequent Events", version: "Post-WB", workiva_export_timestamp: "2/15/2026 3:45 PM PST", execution_completion: "2/15/2026 4:10 PM PST", status: "Tie-Out Created", last_updated: "2/15/2026 4:15 PM PST" },
    ];

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(selectedId === "post-wb" ? postDocs : preDocs);
        }, 1000);
    });
};

const TieOutPage = (props) => {
    const gridRef = useRef();
    const tabsRef = useRef();
    const userId = useSelector((globalState) => globalState.auth.userId);
    const currentStage = useSelector((globalState) => globalState.auth.currentStage);

    const [entityList, setEntityList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [quickFilterText, setQuickFilterText] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [resultTabs, setResultTabs] = useState([]);
    const [selectedId, setSelectedId] = useState("pre-wb");
    const [showHistory, setShowHistory] = useState(false);
    const [savedFilters, setSavedFilters] = useState({});
    const [haveFiltersChanged, setHaveFiltersChanged] = useState(false);
    const [pendingFilterModel, setPendingFilterModel] = useState(null);
    const [dataRendered, setDataRendered] = useState(false);

    const TIEOUT_FILTER_PREFERENCE_TYPE = `TIEOUT_FILTER`;
    const TIEOUT_ASSOCIATION_ID = `TIEOUT_FILTER_ALIAS#${userId}`;
    const TIEOUT_ASSOCIATION_TYPE = 'TIEOUT_FILTER_ALIAS';

    const history = useHistory();
    const location = useLocation();


    const defaultColDef = { filter: true, sortable: true, resizable: true, filterParams: { buttons: ['reset'], debounceMs: 200 } };
    const columnDefs = [
        { field: 'section', headerName: 'Section', flex: 2, checkboxSelection: true, headerCheckboxSelection: true },
        { field: 'version', headerName: 'Version', flex: 1 },
        { field: 'workiva_export_timestamp', headerName: 'Workiva Export Timestamp', width: 100 },
        { field: 'execution_completion', headerName: 'Execution Completion', width: 160 },
        { field: 'status', headerName: 'Status', width: 160 },
        { field: 'last_updated', headerName: 'Last Updated', width: 160 },
    ];

    useEffect(() => {
        loadView();
    }, [selectedId]);

    useEffect(() => {
        if (userId) {
            loadSavedFilters();
        }
    }, [userId]);

    useEffect(() => {
        if (dataRendered && pendingFilterModel) {
            gridRef.current.api.setFilterModel(pendingFilterModel);
            setPendingFilterModel(null);
        }
    }, [dataRendered, pendingFilterModel]);

    useEffect(() => {
            onFilterTextBoxChanged();
    }, [quickFilterText]);

    function onFilterTextBoxChanged() {
        gridRef?.current?.api?.setGridOption(
        "quickFilterText",
        quickFilterText,
        );
    }

    const loadView = () => {
        fetchEntities(selectedId);
    };

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             setLoading(true);
    //             const docName = quarter?.startsWith('Q1') ? '10K' : '10Q';
    //             const data = await getDocumentTreeWithTracks({ quarter, associationId, associationType, documentName: docName });
    //             console.log("GOT DATA", data)
    //             const rows = (Array.isArray(data) ? data : []).map(row => {
    //                 const attrs = typeof row.custom_attributes === 'string'
    //                     ? JSON.parse(row.custom_attributes)
    //                     : (row.custom_attributes || {});
    //                 return {
    //                     ...row,
    //                     page: attrs.PAGE || '',
    //                     pre_wb_due_date: attrs.PRE_WB_DUE_DATE || '',
    //                     post_wb_due_date: attrs.POST_WB_DUE_DATE || '',
    //                     tieout: attrs.TIE_OUT_YN || '',
    //                     part_name: row.part_name || '',
    //                     preparer: (typeof row.preparers === 'string' ? JSON.parse(row.preparers) : (row.preparers || [])).map(p => p.alias).join(', '),
    //                     reviewer: (typeof row.reviewers === 'string' ? JSON.parse(row.reviewers) : (row.reviewers || [])).map(r => r.alias).join(', '),
    //                     service_mappings: typeof row.service_mappings === 'string' ? JSON.parse(row.service_mappings) : (row.service_mappings || []),
    //                 };
    //             });
    //             setSections(rows);
    //         } catch (e) {
    //             console.error('Failed to fetch document tree', e);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };
    //     if (associationId && associationType) {
    //         fetchData();
    //     }
    // }, [quarter, associationId, associationType]);

    const loadSavedFilters = () => {
        if (!userId) return;
        listPreference(
            TIEOUT_ASSOCIATION_ID,
            TIEOUT_ASSOCIATION_TYPE,
            TIEOUT_FILTER_PREFERENCE_TYPE,
            function onSuccess(response) {
                const userFilter = response?.data?.listPreference?.items?.[0];
                if (userFilter) {
                    setSavedFilters(userFilter);
                    setHaveFiltersChanged(false);
                    const filterModel = JSON.parse(userFilter.information);
                    setPendingFilterModel(filterModel);
                }
            },
            function onFailure(error) {
                console.error('Error loading saved filters:', error);
            }
        );
    };

    const saveCurrentFilters = async () => {
        if (!gridRef?.current?.api) return;
        const previouslySavedFilters = savedFilters;
        const currentFilterModel = gridRef.current.api.getFilterModel();

        await new Promise((resolve) => {
            const newPreferenceId = uuidv4();
            createPreference(
                newPreferenceId,
                TIEOUT_FILTER_PREFERENCE_TYPE,
                `${userId}'s TieOut Filters`,
                TIEOUT_ASSOCIATION_ID,
                TIEOUT_ASSOCIATION_TYPE,
                userId,
                currentFilterModel,
                null,
                function onSuccess(response) {
                    const newFilter = {
                        preferenceId: newPreferenceId,
                        preferenceType: TIEOUT_FILTER_PREFERENCE_TYPE,
                        label: `${userId}'s TieOut Filters`,
                        information: JSON.stringify(currentFilterModel),
                    };
                    setSavedFilters(newFilter);
                    setHaveFiltersChanged(false);
                    resolve();
                },
                function onFailure(error) {
                    console.error('Error saving filters:', error);
                    resolve();
                }
            );
        });

        if (previouslySavedFilters?.preferenceId) {
            await new Promise((resolve) => {
                deletePreference(
                    previouslySavedFilters.preferenceId,
                    null,
                    () => resolve(),
                    (error) => {
                        console.error('Error deleting old filter:', error);
                        resolve();
                    }
                );
            });
        }
    };

    const onFilterChanged = useCallback(() => {
        if (!gridRef?.current?.api) return;
        const filterModel = gridRef.current.api.getFilterModel();
        const savedFiltersModel = savedFilters?.information ? JSON.parse(savedFilters?.information) : {};
        setHaveFiltersChanged(!deepEqual(savedFiltersModel, filterModel));
    }, [savedFilters]);

    const onFirstDataRendered = useCallback((params) => {
        setDataRendered(true);
    }, []);

    const fetchEntities = async (id) => {
        setIsLoading(true);
        const data = await mockGetDocuments(id);
        setEntityList(data);
        setIsLoading(false);
    };

    const onSelectionChanged = () => {
        const selectedRows = gridRef?.current?.api?.getSelectedRows();
        setSelectedRows(selectedRows);
    };

    const clearResultsSection = () => {
        setResultTabs([]);
    };

    const viewResults = (selectedRows) => {
        let tabs = [];
        for (let selectedRow of selectedRows) {
        tabs.push({
            label: selectedRow.section || 'Result',
            id: selectedRow.section,
            dismissible: true,
            dismissLabel: "Dismiss",
            onDismiss: () => {
            setResultTabs(prevTabs => prevTabs.filter(tab => tab.id !== selectedRow.section));
            },
            content: (
                <Box padding="l">
                    <SpaceBetween direction="vertical" size="m">
                        <Box float="right">
                            <DownloadTieOutResultsButton data={selectedRow} />
                        </Box>
                        <StatusIndicator type="info">
                            Tie-out results for {selectedRow.section} will appear here.
                        </StatusIndicator>
                    </SpaceBetween>
                </Box>
            )
        });
        }
        setResultTabs(tabs);
        setTimeout(() => {
        tabsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    };

    if (showHistory) {
        return (
            <Box margin="l">
                <TieOutHistoryComponent onBack={() => setShowHistory(false)} />
            </Box>
        );
    }

    return (
        <Box margin="l">
        <SpaceBetween direction="vertical">
            <Grid
            gridDefinition={[
                { colspan: { default: 3, xxs: 3 } },
                { colspan: { default: 9, xxs: 9 } }
            ]}
            >
            <div className="grid-column-wrapper">
                <Container>
                <SpaceBetween direction="vertical" size="l">
                    <div className="left-container"> <img className="icon" src={tieoutLogo}></img></div>
                    <Box variant="strong">Hello, {userId}!</Box>
                    <Box variant="p">I am your friendly AI financial statement reviewer. I catch potential issues before Reviewer1(R1) review</Box>
                    <Box variant="p">The source of the Financial statements is the Workiva bulk export to S3. Results will be available within 2-3 mins from triggering the bulk export.</Box>
                    <Box>
                    <Box>
                        <Box variant="strong">Let's get started:</Box>
                        <Box variant="p">
                            <ol>
                            <li>Select one or multiple 10K/10Q sections</li>
                            <li>Click view results</li>
                            </ol>
                        </Box>
                    </Box>
                    </Box>
                    <Box variant="p">View past reviews in History</Box>
                </SpaceBetween>
                </Container>
            </div>

            <div className="grid-column-wrapper">
                <div className="right-column-content">
                <div className="search-buttons-row">
                    <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
                    <Input
                        onChange={({ detail }) => setQuickFilterText(detail.value)}
                        value={quickFilterText}
                        expandToViewport={true}
                        placeholder='Type to search'
                    />
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="s">
                        {selectedRows?.length <= 0 && resultTabs?.length > 0 && (
                            <Button onClick={() => clearResultsSection()} variant="primary">Clear results</Button>
                        )}
                        <Button onClick={() => viewResults(selectedRows)} disabled={!selectedRows || selectedRows?.length <= 0} variant="primary">View results</Button>
                        <Button onClick={() => setShowHistory(true)} variant="normal">History</Button>
                        <Button variant="normal"
                            onClick={() => {
                                if (haveFiltersChanged) {
                                    saveCurrentFilters();
                                } else {
                                    gridRef?.current?.api?.setFilterModel(null);
                                    setHaveFiltersChanged(false);
                                }
                            }}
                        >
                            {haveFiltersChanged ? 'Save filters' : 'Clear filters'}
                        </Button>
                        </SpaceBetween>
                    </Box>
                    </Grid>
                </div>
                <Box>
                    <SegmentedControl
                        selectedId={selectedId}
                        onChange={({ detail }) =>
                            setSelectedId(detail.selectedId)
                        }
                        label="WB Control Select"
                        options={[
                            { text: "Pre-WB", id: "pre-wb" },
                            { text: "Post-WB", id: "post-wb" },
                        ]}
                    />
                </Box>
                <div className="ag-grid-wrapper">
                    <div className="ag-theme-alpine">
                    <AgGridReact
                        ref={gridRef}
                        rowData={entityList}
                        defaultColDef={defaultColDef}
                        columnDefs={columnDefs}
                        enableRangeSelection={true}
                        rowSelection="multiple"
                        suppressRowClickSelection={true}
                        onSelectionChanged={onSelectionChanged}
                        animateRows={true}
                        pagination={true}
                        paginationPageSize={10}
                        paginationPageSizeSelector={[10, 50, 100]}
                        loading={isLoading}
                        onFirstDataRendered={onFirstDataRendered}
                        onFilterChanged={onFilterChanged}
                    />
                    </div>
                </div>
                </div>
            </div>
            </Grid>

            {
                resultTabs?.length > 0 && (
                    <Box>
                        <div className="tieout-result-title-wrapper">
                            <SpaceBetween>
                                <Box variant="h4">
                                    <SpaceBetween size="s" direction="horizontal">
                                        <img
                                            className="ai-button"
                                            src={aiInsights}
                                        />
                                            Results Generated by AI
                                    </SpaceBetween>
                                </Box>
                                <Box>
                                    <i>
                                        AI has limitations and may produce omissions or errors. Please review all important information.
                                    </i>
                                </Box>
                            </SpaceBetween>
                        </div>
                        <Container>
                            <div ref={tabsRef}>
                                <SpaceBetween direction="vertical" size="m">
                                    <Tabs tabs={resultTabs} />
                                </SpaceBetween>
                            </div>
                        </Container>
                    </Box>
                )
            }
        </SpaceBetween>
        </Box>
    );
};

export default TieOutPage;
